export enum ServiceOrdersStatusEnum {
    CONCLUDED = 'CONCLUIDA',
    APPROVED = 'APROVADA',
    PENDING = 'PENDENTE',
    PENDING_PAYMENT = 'PENDENTE DE PAGAMENTO',
    IN_PROGRESS = 'EM TESTE',
    REJECTED = 'REPROVADA',
    CANCELED = 'CANCELADA',
    IN_ANALISING = 'EM ANALISE',
    ALL = 'TODOS',
}

